import { Directive, Input, TemplateRef, ViewContainerRef, inject } from "@angular/core";

interface LetContext<T> {
  appLet: T;
}

@Directive({
  selector: "[appLet]",
  standalone: true,
})
export class LetDirective<T> {
  private readonly _context: LetContext<T> = { appLet: null as unknown as T };

  constructor() {
    const _viewContainer = inject(ViewContainerRef);
    const _templateRef = inject<TemplateRef<LetContext<T>>>(TemplateRef);

    _viewContainer.createEmbeddedView(_templateRef, this._context);
  }

  @Input()
  set appLet(value: T) {
    this._context.appLet = value;
  }
}
